// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getRecentlyCompletedProgressionAnalyses } from "../../api";
import { ProgressionAnalysisType } from "../../types";

export const useRecentlyCompletedProgressionAnalysesData = (
  clinicId: string | undefined,
  payload: { recentFilterDate: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ProgressionAnalysisType>>({
    queryKey: ["recent-progression-analyses", clinicId, payload],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getRecentlyCompletedProgressionAnalyses(
        token,
        clinicId,
        payload,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
